// extracted by mini-css-extract-plugin
export default {"modal-header":"AddHolidayManuallyModal_modal-header__rtiKE","form-container-head-warning":"AddHolidayManuallyModal_form-container-head-warning__MUyUN"};